<div
    class="ui-field has-icon has-suffix"
    [class.floated]="true"
    [class.focused]="focused"
    [class.invalid]="!!errorText"
    [class.disabled]="disabled"
    [class.required]="required"
>
    <div class="ui-field__control-row">
        <span class="ui-field__icon">
            <ui-icon name="calendar"></ui-icon>
        </span>

        <input
            [id]="id"
            class="ui-field__control"
            readonly
            [matDatepicker]="picker"
            [value]="dateValue"
            [min]="min"
            [max]="max"
            [attr.required]="required ? '' : null"
            [attr.aria-invalid]="errorText ? true : null"
            [disabled]="disabled"
            (dateChange)="onDateChange($event.value)"
            (focus)="onFocus()"
            (blur)="onBlur()"
            (click)="picker.open()"
        />

        <label class="ui-field__label" [for]="id">{{ label }}</label>

        <span class="ui-field__suffix">
            <mat-datepicker-toggle [for]="picker" tabindex="-1"></mat-datepicker-toggle>
        </span>
        <mat-datepicker #picker></mat-datepicker>
    </div>

    <span class="ui-field__hint" *ngIf="hint && !errorText">{{ hint }}</span>
    <span class="ui-field__error" role="alert" *ngIf="errorText">{{ errorText }}</span>
</div>
